/**
 * Error returned when maximum precision is exceeded
 */
export default class DecimalPrecisionError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}
